export default __webpack_public_path__ + "static/media/purple_shadown_circle.26a776a7.svg";